export const menubar = {
    namespaced: true,
    state: {
        menus: {},
        change: {}
    },

    getters: {
        getMenus(state) {
            return state.menus;
        },
        onChange(state) {
            return state.change;
        },
        isActive: state => (idMenu, id) => {
            return state.menus[idMenu].includes(id);
        }
    },

    mutations: {
        ADD_MENU(state, idMenu) {
            state.menus[idMenu] = [];
        },

        ADD_MENU_ITEM_ACTIVE(state, obj) {
            let menuItems = state.menus[obj.idMenu];
            if (!menuItems.includes(obj.id)) {
                state.menus[obj.idMenu] = [];
                state.menus[obj.idMenu].push(obj.id);
            } else {
                state.menus[obj.idMenu] = [];
            }

            state.change = obj;
        }
    },

    actions: {
        addMenu(context, idMenu) {
            context.commit("ADD_MENU", idMenu);
        },

        addMenuItemActive(context, obj) {
            context.commit("ADD_MENU_ITEM_ACTIVE", obj);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/gui/menubar.js